<template>
  <div class="">
    <div class="row">
      <ghabz @indexSelected="openGhabz" :indexActive="inx"></ghabz>
      <div class="col-12 px-5 mt-2">
        <hr class="bg-secondar" />
      </div>
      <!-- <div class="col-12 px-5 mt-2 text-center" v-if="inx==0" dir="rtl">
                <div class="">
                    <h6>شناسه قبض آب را وارد نمایید  </h6><input class="form-control d-inline w-25 text-center" type="text" style="font-size:20px" >
                </div>
                <button class="btn btn-success mt-2 text-center pt-3 w-25"><h6>استعـــــــلام قبض</h6></button>
            </div> -->
    </div>
    <div class="row">
      <div class="col-lg-4 col-12 border-left px-3">
        <div class="Card mt-2 text-center">
          <div class="h5 text-center">انتخاب حساب</div>
          <p class="px-3">حساب مورد نظر جهت کسر مبلغ قبض را انتخاب نمایید</p>
          <div class="px-3">
            <select class="form-control" v-model="Taahodat">
              <option :value="item" class="text-center" v-for="(item, key) in listTaahodat" :key="key">
                <span>{{ item.vcodeDesNo }}</span>
              </option>
            </select>
            <div v-if="inx == 0" class="border-dash-water mt-4"></div>
            <div v-if="inx == 1" class="border-dash-electricity mt-4"></div>
            <div v-if="inx == 2" class="border-dash-gas mt-4"></div>
            <div v-if="inx == 3" class="border-dash-Mobile mt-4"></div>
            <div v-if="inx == 4" class="border-dash-fixedLine mt-4"></div>
          </div>
          <div class="px-3 mt-5" v-if="Taahodat && Taahodat.id">
            <span class="float-right"> موجودی قابل برداشت</span>
            <span class="h6 float-left font-weight-bold text-dark text-center">{{ $Comma3ragham(Taahodat.ghabelBardasht) }} ریال</span>
            <button v-if="inx == 0" class="btn btn-water mt-2 text-center pt-3 w-100 mt-3" @click="taahodatId = Taahodat.bnpCashDBtblTaahodatId"><h6>انتخاب و تایید حساب</h6></button>
            <button v-if="inx == 1" class="btn btn-electricity mt-2 text-center pt-3 w-100 mt-3" @click="taahodatId = Taahodat.bnpCashDBtblTaahodatId"><h6>انتخاب و تایید حساب</h6></button>
            <button v-if="inx == 2" class="btn btn-gas mt-2 text-center pt-3 w-100 mt-3 text-light" @click="taahodatId = Taahodat.bnpCashDBtblTaahodatId"><h6>انتخاب و تایید حساب</h6></button>
            <button v-if="inx == 3" class="btn btn-mobile mt-2 text-center pt-3 w-100 mt-3 text-light" @click="taahodatId = Taahodat.bnpCashDBtblTaahodatId"><h6>انتخاب و تایید حساب</h6></button>
            <button v-if="inx == 4" class="btn btn-fixedLine mt-2 text-center pt-3 w-100 mt-3 text-light" @click="taahodatId = Taahodat.bnpCashDBtblTaahodatId"><h6>انتخاب و تایید حساب</h6></button>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-12 border-left px-3" v-if="taahodatId != null">
        <!-- آب -->
        <div class="px-lg-5 px-1 mt-2 Card" v-if="inx == 0" dir="rtl" id="Water">
          <div class="mb-5 text-right">
            <div class="cardGhabz cardGhabz_Water d-inline ml-2">
              <img src="../../../public/Template/NewMenu/img/Ghabz/faucet.png" width="8%" />
            </div>
            <h5 class="font-weight-bold d-inline">شناسه قبض آب را وارد نمایید</h5>
          </div>
          <div class="text-center">
            <h6>برای استعلام، شناسه قبض آب را وارد کنید</h6>
            <input class="form-control d-inline w-100 text-center mt-2 required" type="number" style="font-size: 20px" v-model="waterBillId" />
          </div>
          <button class="btn btn-water mt-2 text-center pt-3 w-100 mt-3" @click="Inquiry_Water"><h6>استعـــــــلام جزئیات قبض آب</h6></button>
          <div class="border-dash-water mt-4"></div>
          <div class="row text-right">
            <div class="col-12 infoSave Pointer px-3" v-for="(item, key) in listSave" :key="key" @click="waterBillId = item.billId">
              <div class="mt-2" :key="Render">
                <div class="mx-3">
                  <span>قبض آب </span>
                  <span class="float-left">{{ item.fullName }}</span>
                </div>
                <span class="float-right hover-danger Pointer mr-1" @click="deleteSave(item)"><i class="fa fa-trash" title="حذف"></i></span>
                <span class="float-left mt-1"
                  ><h6>{{ item.participateCode == null ? item.billId : item.participateCode }}</h6></span
                >
              </div>
            </div>
          </div>
        </div>
        <!-- برق -->
        <div class="px-lg-5 px-1 mt-2 Card" v-if="inx == 1" dir="rtl" id="Electrici">
          <div class="mb-5 text-right">
            <div class="cardGhabz cardGhabz_Electricity d-inline ml-2">
              <img src="../../../public/Template/NewMenu/img/Ghabz/lightbulb-on.png" width="8%" />
            </div>
            <h5 class="font-weight-bold d-inline">شناسه قبض برق را وارد نمایید</h5>
          </div>
          <div class="text-center">
            <h6>برای استعلام، شناسه قبض برق را وارد کنید</h6>
            <input class="form-control d-inline w-100 text-center mt-2 required" type="number" style="font-size: 20px" v-model="electricityBillId" />
          </div>
          <button class="btn btn-electricity mt-2 text-center pt-3 w-100 mt-3" @click="Inquiry_Electricity"><h6>استعـــــــلام جزئیات قبض برق</h6></button>
          <div class="border-dash-electricity mt-4"></div>
          <div class="row text-right">
            <div class="col-12 infoSave Pointer px-3" v-for="(item, key) in listSave" :key="key" @click="electricityBillId = item.billId">
              <div class="mt-2" :key="Render">
                <div class="mx-3">
                  <span>قبض برق </span>
                  <span class="float-left">{{ item.fullName }}</span>
                </div>
                <span class="float-right hover-danger Pointer mr-1" @click="deleteSave(item)"><i class="fa fa-trash" title="حذف"></i></span>
                <span class="float-left mt-1"
                  ><h6>{{ item.participateCode == null ? item.billId : item.participateCode }}</h6></span
                >
              </div>
            </div>
          </div>
        </div>
        <!-- گاز -->
        <div class="px-lg-5 px-1 mt-2 Card" v-if="inx == 2" dir="rtl" id="Gas">
          <div class="mb-5 text-right">
            <div class="cardGhabz cardGhabz_Gas d-inline ml-2">
              <img src="../../../public/Template/NewMenu/img/Ghabz/fire-burner.png" width="8%" />
            </div>
            <h5 class="font-weight-bold d-inline">مشاهده و پرداخت قبض گاز</h5>
          </div>
          <div class="text-center">
            <div class="my-4">
              <p>روش استعلام را انتخاب کنید</p>
              <div class="form-control text-center mt-1">
                <div class="custom-control text-center custom-switch">
                  <h6 id="LbltblComboGrpId50" class="ml-2 d-inline">شناسه قبض</h6>
                  <input type="checkbox" class="custom-control-input required InputText Pointer" id="Done" v-model="isBillGas" />
                  <label class="custom-control-label Pointer" for="Done"> </label>
                  <h6 class="mr-5 d-inline">شماره اشتراک</h6>
                </div>
              </div>
            </div>
            <h6 v-if="isBillGas == false">شماره اشتراک را وارد کنید</h6>
            <h6 v-if="isBillGas == true">شناسه قبض گاز را وارد کنید</h6>
            <input class="form-control d-inline w-100 text-center mt-2 required" type="number" style="font-size: 20px" placeholder="شماره اشتراک" v-model="gasParticipateCode" v-if="isBillGas == false" />
            <input class="form-control d-inline w-100 text-center mt-2 required" type="number" style="font-size: 20px" placeholder="شناسه قبض" v-model="gasBillId" v-if="isBillGas == true" />
          </div>
          <button class="btn btn-gas mt-2 text-center pt-3 w-100 mt-3 text-light" @click="Inquiry_Gas"><h6>استعـــــــلام جزئیات قبض گاز</h6></button>
          <div class="border-dash-gas mt-4"></div>
          <div class="row text-right">
            <div class="col-12 infoSave Pointer px-3" v-for="(item, key) in listSave" :key="key" @click="replaceGasSaved(item)">
              <div class="mt-2" :key="Render">
                <div class="mx-3">
                  <span>قبض گاز </span>
                  <span class="float-left">{{ item.fullName }}</span>
                </div>
                <span class="float-right hover-danger Pointer mr-1" @click="deleteSave(item)"><i class="fa fa-trash" title="حذف"></i></span>
                <span class="float-left mt-1"
                  ><h6>{{ item.participateCode == null ? item.billId : item.participateCode }}</h6></span
                >
              </div>
            </div>
          </div>
        </div>
        <!-- همراه -->
        <div class="px-lg-5 px-1 mt-2 Card" v-if="inx == 3" dir="rtl" id="Mobile">
          <div class="mb-5 text-right">
            <div class="cardGhabz cardGhabz_Mobile d-xl-inline d-none ml-2">
              <img src="../../../public/Template/NewMenu/img/Ghabz/sim-cards.png" width="8%" />
            </div>
            <h5 class="font-weight-bold d-inline">پرداخت قبض تلفن همراه</h5>
          </div>
          <div class="text-center">
            <h6>شماره تلفن همراه خود را وارد کنید</h6>
            <input class="form-control d-inline w-100 text-center mt-2 required" type="text" style="font-size: 20px" @input="checkOperationSim" v-mask="'####-#######'" v-model="mobileNumber" dir="ltr" />
          </div>
          <div class="row mt-3 mx-1 text-center">
            <div class="col-lg-4 col-12" :class="operationSim == 'MTN' ? 'text-warning font-weight-bold h6' : ''">ایرانسل</div>
            <div class="col-lg-4 col-12" :class="operationSim == 'MCI' ? 'text-info font-weight-bold h6' : ''">همراه اول</div>
            <div class="col-lg-4 col-12" :class="operationSim == 'RIGHTEL' ? 'text-banafsh font-weight-bold h6' : ''">رایتل</div>
          </div>
          <button class="btn btn-mobile mt-2 text-center pt-3 w-100 mt-3 text-light" @click="Inquiry_Mobile"><h6>استعـــــــلام جزئیات تلفن همراه</h6></button>
          <div class="border-dash-Mobile mt-4"></div>
          <div class="row text-right">
            <div class="col-12 infoSave Pointer px-3" v-for="(item, key) in listSave" :key="key" @click="ReplaceMobileSave(item)">
              <div class="mt-2" :key="Render">
                <div class="mx-3">
                  <span>قبض تلفن همراه </span>
                  <span class="float-left"></span>
                </div>
                <span class="float-right hover-danger Pointer mr-1" @click="deleteSave(item)"><i class="fa fa-trash" title="حذف"></i></span>
                <span class="float-left mt-1"
                  ><h6>{{ item.participateCode == null ? item.billId : item.participateCode }}</h6></span
                >
              </div>
            </div>
          </div>
        </div>
        <!-- ثابت -->
        <div class="px-lg-5 px-1 mt-2 Card" v-if="inx == 4" dir="rtl" id="FixedLine">
          <div class="mb-5 text-right">
            <div class="cardGhabz cardGhabz_FixedLine d-inline ml-2">
              <img src="../../../public/Template/NewMenu/img/Ghabz/phone-office.png" width="8%" />
            </div>
            <h5 class="font-weight-bold d-inline">پرداخت قبض تلفن ثابت</h5>
          </div>
          <div class="text-center">
            <h6>شماره تلفن ثابت + کد شهر خود را وارد کنید</h6>
            <input class="form-control d-inline w-100 text-center mt-2 required" type="text" style="font-size: 20px" v-mask="'###-########'" v-model="fixedLineNumber" />
          </div>
          <button class="btn btn-fixedLine mt-2 text-center pt-3 w-100 mt-3 text-light" @click="Inquiry_FixedLine"><h6>استعـــــــلام جزئیات تلفن ثابت</h6></button>
          <div class="border-dash-fixedLine mt-4"></div>
          <div class="row text-right">
            <div class="col-12 infoSave Pointer px-3" v-for="(item, key) in listSave" :key="key" @click="fixedLineNumber = item.billId">
              <div class="mt-2" :key="Render">
                <div class="mx-3">
                  <span>قبض تلفن ثابت </span>
                  <span class="float-left"></span>
                </div>
                <span class="float-right hover-danger Pointer mr-1" @click="deleteSave(item)"><i class="fa fa-trash" title="حذف"></i></span>
                <span class="float-left mt-1"
                  ><h6>{{ item.participateCode == null ? item.billId : item.participateCode }}</h6></span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-12 border-left px-3" v-if="estelamIsSuccess">
        <!-- آب -->
        <div class="px-lg-5 px-1 mt-2 text-center Card" dir="rtl" v-if="inx == 0">
          <h5>جزئــــــــــــیات قبض</h5>
          <div class="border-dash-water mt-4"></div>
          <div class="text-right mt-5">
            <span class="h6">شناسه قبض : </span>
            <span class="h6 float-left">{{ inquiryWater.BillID }}</span>
          </div>
          <div class="text-right mt-2">
            <span class="h6">آدرس : </span>
            <span class="h6 float-left">{{ inquiryWater.Address }}</span>
          </div>
          <div class="text-right mt-2">
            <span class="h6">مشخصات : </span>
            <span class="h6 float-left">{{ inquiryWater.FullName }}</span>
          </div>
          <div class="text-right mt-2">
            <span class="h6">مبلغ قابل پرداخت : </span>
            <span class="h6 float-left text-dark font-weight-bold">{{ $Comma3ragham(inquiryWater.Amount) }} </span> ریال
          </div>
          <div class="text-center mt-3">
            <span class="h6 text-dark font-weight-bold">{{ $Mab2persianRial($Comma3ragham(inquiryWater.Amount)) }} </span>
          </div>
          <div class="border-dash-water mt-4"></div>
          <button class="btn btn-water mt-4 text-center pt-3 w-100 mt-2 text-dark" @click="paymentWater(inquiryWater, Taahodat)"><h6>تایید و پرداخت قبض</h6></button>
        </div>
        <!-- برق -->
        <div class="px-lg-5 px-1 mt-2 text-center Card" dir="rtl" v-if="inx == 1">
          <h5>جزئــــــــــــیات قبض</h5>
          <div class="border-dash-Mobile mt-4"></div>
          <div class="text-right mt-5">
            <span class="h6">شناسه قبض : </span>
            <span class="h6 float-left">{{ inquiryElectricity.BillID }}</span>
          </div>
          <div class="text-right mt-2">
            <span class="h6">شناسه پرداخت : </span>
            <span class="h6 float-left">{{ inquiryElectricity.PaymentID }}</span>
          </div>
          <div class="text-right mt-2">
            <span class="h6">آدرس : </span>
            <span class="h6 float-left">{{ inquiryElectricity.Address }}</span>
          </div>
          <div class="text-right mt-2">
            <span class="h6">مشخصات : </span>
            <span class="h6 float-left">{{ inquiryElectricity.FullName }}</span>
          </div>
          <div class="text-right mt-2">
            <span class="h6">نوع تعرفه : </span>
            <span class="h6 float-left">{{ inquiryElectricity.TariffType }}</span>
          </div>
          <div class="text-right mt-2">
            <span class="h6">نوع مشترک : </span>
            <span class="h6 float-left">{{ inquiryElectricity.CustomerType }}</span>
          </div>
          <div class="text-right mt-2">
            <span class="h6">مبلغ قابل پرداخت : </span>
            <span class="h6 float-left text-dark font-weight-bold">{{ $Comma3ragham(inquiryElectricity.Amount) }} </span> ریال
          </div>
          <div class="text-center mt-3">
            <span class="h6 text-dark font-weight-bold">{{ $Mab2persianRial($Comma3ragham(inquiryElectricity.Amount)) }} </span>
          </div>
          <div class="border-dash-Mobile mt-4"></div>
          <button class="btn btn-electricity mt-4 text-center pt-3 w-100 mt-2 text-dark" @click="paymentElectricity(inquiryElectricity, Taahodat)"><h6>تایید و پرداخت قبض</h6></button>
        </div>
        <!-- گاز -->
        <div class="px-lg-5 px-1 mt-2 text-center Card" dir="rtl" v-if="inx == 2">
          <h5>جزئــــــــــــیات قبض</h5>
          <div class="border-dash-Mobile mt-4"></div>
          <div class="text-right mt-5">
            <span class="h6">شناسه قبض : </span>
            <span class="h6 float-left">{{ inquiryGas.BillID }}</span>
          </div>
          <div class="text-right mt-2">
            <span class="h6">شناسه پرداخت : </span>
            <span class="h6 float-left">{{ inquiryGas.PaymentID }}</span>
          </div>
          <div class="text-right mt-2">
            <span class="h6">آدرس : </span>
            <span class="h6 float-left">{{ inquiryGas.Address }}</span>
          </div>
          <div class="text-right mt-2">
            <span class="h6">مشخصات : </span>
            <span class="h6 float-left">{{ inquiryGas.FullName }}</span>
          </div>
          <div class="text-right mt-2">
            <span class="h6">نوع مصرف : </span>
            <span class="h6 float-left">{{ inquiryGas.ConsumptionType }}</span>
          </div>
          <div class="text-right mt-2">
            <span class="h6">مبلغ قابل پرداخت : </span>
            <span class="h6 float-left text-dark font-weight-bold">{{ $Comma3ragham(inquiryGas.Amount) }} </span> ریال
          </div>
          <div class="text-center mt-3">
            <span class="h6 text-dark font-weight-bold">{{ $Mab2persianRial($Comma3ragham(inquiryGas.Amount)) }} </span>
          </div>
          <div class="border-dash-Mobile mt-4"></div>
          <button class="btn btn-gas mt-4 text-center pt-3 w-100 mt-2 text-light" @click="paymentGas(inquiryGas, Taahodat)"><h6>تایید و پرداخت قبض</h6></button>
        </div>
        <!-- موبایل -->
        <div class="px-lg-5 px-1 mt-2 text-center Card" dir="rtl" v-if="inx == 3">
          <h5>جزئــــــــــــیات قبض</h5>
          <div class="border-dash-Mobile mt-4"></div>
          <div class="text-right mt-5">
            <span class="h6">شناسه قبض : </span>
            <span class="h6 float-left">{{ inquiryMobileData.BillID }}</span>
          </div>
          <div class="text-right mt-2">
            <span class="h6">شماره اشتراک : </span>
            <span class="h6 float-left">{{ inquiryMobileData.PaymentID }}</span>
          </div>
          <div class="text-right mt-2">
            <span class="h6">مبلغ قابل پرداخت : </span>
            <span class="h6 float-left text-dark font-weight-bold">{{ $Comma3ragham(inquiryMobileData.Amount) }} </span> ریال
          </div>
          <div class="text-center mt-3">
            <span class="h6 text-dark font-weight-bold">{{ $Mab2persianRial($Comma3ragham(inquiryMobileData.Amount)) }} </span>
          </div>
          <div class="border-dash-Mobile mt-4"></div>
          <button class="btn btn-mobile mt-4 text-center pt-3 w-100 mt-2 text-light" @click="paymentMobile(inquiryMobileData, Taahodat)"><h6>تایید و پرداخت قبض</h6></button>
        </div>
        <!-- ثابت -->
        <div class="px-lg-5 px-1 mt-2 text-center Card" dir="rtl" v-if="inx == 4">
          <h5>جزئــــــــــــیات قبض</h5>
          <div class="border-dash-fixedLine mt-4"></div>
          <div class="text-right mt-5">
            <span class="h6">پایان دوره : </span>
            <span v-if="inquiryFixedLine.FinalTerm != null" class="h6 float-left text-dark font-weight-bold">{{ $Comma3ragham(inquiryFixedLine.FinalTerm.Amount) }} </span> <span v-if="inquiryFixedLine.FinalTerm != null">ریال</span>
            <button v-if="inquiryFixedLine.FinalTerm != null" class="btn btn-fixedLine text-center pt-3 w-100 text-light" @click="paymentFixedLine(inquiryFixedLine.FinalTerm, Taahodat)"><h6>پرداخت پایـــان دوره</h6></button>
            <div v-else class="text-success float-left"><h5>پرداخت شده</h5></div>
          </div>
          <div class="border-dash-fixedLine mt-4"></div>
          <div class="text-right mt-4">
            <span class="h6">میان دوره : </span>
            <span class="h6 float-left text-dark font-weight-bold">{{ $Comma3ragham(inquiryFixedLine.MidTerm.Amount) }} </span> ریال
            <button class="btn btn-fixedLine text-center pt-3 w-100 text-light" @click="paymentFixedLine(inquiryFixedLine.MidTerm, Taahodat)"><h6>پرداخت میــــان دوره</h6></button>
          </div>
          <div class="mt-4"></div>
          <!-- <button class="btn btn-fixedLine mt-4 text-center pt-3 w-100 mt-2 text-light" @click="paymentFixedLine(inquiryFixedLine, Taahodat)"><h6>تایید و پرداخت قبض</h6></button> -->
        </div>
      </div>
    </div>
    <loading v-if="loadingRender"></loading>
  </div>
</template>
<script>
import Loading from '../Tools/NetPa/Loading.vue'
import Ghabz from './Ghabz.vue'
export default {
  components: { Ghabz, Loading },
  data() {
    return {
      listMobile: [
        { MTN: ['0930', '0933', '0935', '0936', '0937', '0938', '0939', '0900', '0901', '0902', '0903', '0904', '0905', '0941'] },
        { MCI: ['0910', '0911', '0912', '0913', '0914', '0915', '0916', '0917', '0918', '0919', '0990', '0991', '0992', '0993', '0994'] },
        { RIGHTEL: ['0920', '0921', '0922'] },
      ],
      operationSim: '',
      inx: null,
      waterBillId: null,
      mobileNumber: null,
      fixedLineNumber: null,
      electricityBillId: null,
      gasBillId: null,
      gasParticipateCode: null,
      estelamIsSuccess: false,
      taahodatId: null,
      loadingRender: false,
      inquiryMobileData: {},
      inquiryFixedLine: {},
      inquiryWater: {},
      inquiryElectricity: {},
      inquiryGas: {},
      listTaahodat: [],
      Taahodat: {},
      isBillGas: false,
      minMandeForInquiry: 10000,
      listSave: [],
      Render: 0,
    }
  },
  props: ['indexMenu'],
  created() {
    this.inx = this.indexMenu
    this.getSelTaahodat()
  },
  mounted() {
    this.getSelTaahodat()
    // this.getBalance()
  },
  methods: {
    openGhabz(index) {
      this.inx = index
      this.estelamIsSuccess = false
      this.getSelTaahodat()
      this.getBillInfo(11 + this.inx)
    },

    Inquiry_Water() {
      if (this.$ValidForm('Water')) {
        if (this.Taahodat.ghabelBardasht <= this.minMandeForInquiry) {
          this.$mySweetDefault('عدم موجودی', 'برای استعلام نباید موجودی حساب شما کمتر از ' + this.$Comma3ragham(this.minMandeForInquiry) + ' ' + this.$GetVahedPool() + ' باشد', 'warning', 4000)
          return
        }
        this.loadingRender = true
        var DataAxios = {
          ArryfildValue: '',
          Method: 'post',
          Action: 'Bill/BillWater',
          Token: this.$session.get('TokenNetPa'),
        }
        const formData = new FormData()
        formData.append('customerCode',this.$session.get('CustCode'))
        formData.append('taahodatId', this.taahodatId)
        formData.append('waterBillId', this.waterBillId)
        formData.append('token', this.$session.get('TokenNetPa'))
        DataAxios.ArryfildValue = formData
        this.$PostFormData(DataAxios).then((res) => {
          try {
            let data = JSON.parse(res)
            if (data.Status.Code == 'Exception') {
              this.loadingRender = false
              this.$mySweetDefault('خطا', data.Status.Description, 'warning', 4000)
            }
            if (data.Status.Code == 'Success') {
              this.loadingRender = false
              this.estelamIsSuccess = true
              this.inquiryWater = data.Parameters
              this.setDebtorRecord(1300, 'هزینه استعلام قبض آب با شناسه  : ' + this.waterBillId)
              this.saveBillInfo(11, this.waterBillId, null, this.inquiryWater.FullName)
              this.getBillInfo(11)
            }
          } catch (error) {
            if (res.status == false) {
              this.loadingRender = false
              this.$mySweetDefault('خطا', res.message, 'warning', 4000)
              return
            }
          }
        })
      }
    },
    Inquiry_Electricity() {
      if (this.$ValidForm('Electrici')) {
        if (this.Taahodat.ghabelBardasht <= this.minMandeForInquiry) {
          this.$mySweetDefault('عدم موجودی', 'برای استعلام نباید موجودی حساب شما کمتر از ' + this.$Comma3ragham(this.minMandeForInquiry) + ' ' + this.$GetVahedPool() + ' باشد', 'warning', 4000)
          return
        }
        this.loadingRender = true
        var DataAxios = {
          ArryfildValue: '',
          Method: 'post',
          Action: 'Bill/BillElectricity',
          Token: this.$session.get('TokenNetPa'),
        }
        const formData = new FormData()
        formData.append('customerCode',this.$session.get('CustCode'))
        formData.append('taahodatId', this.taahodatId)
        formData.append('electricityBillId', this.electricityBillId)
        formData.append('token', this.$session.get('TokenNetPa'))
        DataAxios.ArryfildValue = formData
        this.$PostFormData(DataAxios).then((res) => {
          try {
            let data = JSON.parse(res)
            if (data.Status.Code == 'Exception') {
              this.loadingRender = false
              this.$mySweetDefault('خطا', data.Status.Description, 'warning', 4000)
            }
            if (data.Status.Code == 'Success') {
              this.loadingRender = false
              this.estelamIsSuccess = true
              this.inquiryElectricity = data.Parameters
              this.setDebtorRecord(1300, 'هزینه استعلام قبض برق با شناسه  : ' + this.electricityBillId)
              this.saveBillInfo(12, this.electricityBillId, null, this.inquiryElectricity.FullName)
              this.getBillInfo(12)
            }
          } catch (error) {
            if (res.status == false) {
              this.loadingRender = false
              this.$mySweetDefault('خطا', res.message, 'warning', 4000)
              return
            }
          }
        })
      }
    },
    Inquiry_Gas() {
      if (this.$ValidForm('Gas')) {
        if (this.Taahodat.ghabelBardasht <= this.minMandeForInquiry) {
          this.$mySweetDefault('عدم موجودی', 'برای استعلام نباید موجودی حساب شما کمتر از ' + this.$Comma3ragham(this.minMandeForInquiry) + ' ' + this.$GetVahedPool() + ' باشد', 'warning', 4000)
          return
        }
        this.loadingRender = true
        var DataAxios = {
          ArryfildValue: '',
          Method: 'post',
          Action: 'Bill/BillGas',
          Token: this.$session.get('TokenNetPa'),
        }
        const formData = new FormData()
        formData.append('customerCode',this.$session.get('CustCode'))
        formData.append('taahodatId', this.taahodatId)
        formData.append('participateCode', this.gasParticipateCode)
        formData.append('gasBillId', this.gasBillId)
        formData.append('token', this.$session.get('TokenNetPa'))
        DataAxios.ArryfildValue = formData
        this.$PostFormData(DataAxios).then((res) => {
          try {
            let data = JSON.parse(res)
            if (data.Status.Code == 'Exception') {
              this.loadingRender = false
              this.$mySweetDefault('خطا', data.Status.Description, 'warning', 4000)
            }
            if (data.Status.Code == 'Success') {
              this.loadingRender = false
              this.estelamIsSuccess = true
              this.inquiryGas = data.Parameters
              this.setDebtorRecord(1300, 'هزینه استعلام قبض گاز با شناسه  : ' + this.gasBillId + ' و کد اشتراک :: ' + this.gasParticipateCode)
              this.saveBillInfo(13, this.gasBillId, this.gasParticipateCode, this.inquiryGas.FullName)
              this.getBillInfo(13)
            }
          } catch (error) {
            if (res.status == false) {
              this.loadingRender = false
              this.$mySweetDefault('خطا', res.message, 'warning', 4000)
              return
            }
          }
        })
      }
    },
    Inquiry_Mobile() {
      if (this.$ValidForm('Mobile')) {
        if (this.Taahodat.ghabelBardasht <= this.minMandeForInquiry) {
          this.$mySweetDefault('عدم موجودی', 'برای استعلام نباید موجودی حساب شما کمتر از ' + this.$Comma3ragham(this.minMandeForInquiry) + ' ' + this.$GetVahedPool() + ' باشد', 'warning', 4000)
          return
        }
        if (this.mobileNumber.length < 12) {
          this.$mySweetDefault('خطا', 'تعداد ارقام شماره موبایل صحیح نمی باشد', 'warning', 3000)
          return
        }
        if (this.operationSim == 'MTN') {
          //   var DataAxios = {
          //     ArryfildValue: '',
          //     Method: 'post',
          //     Action: 'Bill/BillMtn',
          //     Token: this.$session.get('TokenNetPa'),
          //   }
          //   const formData = new FormData()
          //   formData.append('customerCode',this.$session.get('CustCode'))
          //   formData.append('taahodatId', 2)
          //   formData.append('mobileNumber', this.mobileNumber.replace('-', ''))
          //   formData.append('token', this.$session.get('TokenNetPa'))
          //   DataAxios.ArryfildValue = formData
          //   this.$PostFormData(DataAxios).then((res) => {
          //     console.log(JSON.parse(res))
          //     let data = JSON.parse(res)
          //     if (data.Status.Code == 'Exception') {
          //       this.$mySweetDefault('خطا', data.Status.Description, 'warning', 3000)
          //     }
          //   })
          this.$mySweetDefault('عدم پرداخت قبض', 'با عرض پوزش ، درحال حاضر فقط امکان پرداخت قبوض خطوط همراه اول دائمی و رایتل دائمی امکان پذیر می باشد', 'info', 4000)
        }
        if (this.operationSim == 'MCI') {
          this.loadingRender = true
          var DataAxios = {
            ArryfildValue: '',
            Method: 'post',
            Action: 'Bill/BillMci',
            Token: this.$session.get('TokenNetPa'),
          }
          const formData = new FormData()
          formData.append('customerCode',this.$session.get('CustCode'))
          formData.append('taahodatId', this.taahodatId)
          formData.append('mobileNumber', this.mobileNumber.replace('-', ''))
          formData.append('token', this.$session.get('TokenNetPa'))
          DataAxios.ArryfildValue = formData
          this.$PostFormData(DataAxios).then((res) => {
            try {
              let data = JSON.parse(res)
              if (data.Status.Code == 'Exception') {
                this.loadingRender = false
                this.$mySweetDefault('خطا', data.Status.Description, 'warning', 4000)
              }
              if (data.Status.Code == 'Success') {
                this.loadingRender = false
                this.estelamIsSuccess = true
                this.inquiryMobileData = data.Parameters.MidTerm
                this.setDebtorRecord(1300, 'هزینه استعلام قبض موبایل همراه اول با شناسه  : ' + this.mobileNumber.replace('-', ''))
                this.saveBillInfo(14, this.mobileNumber, null, null)
                this.getBillInfo(14)
              }
            } catch (error) {
              if (res.status == false) {
                this.loadingRender = false
                this.$mySweetDefault('خطا', res.message, 'warning', 4000)
                return
              }
            }
          })
        }
        if (this.operationSim == 'RIGHTEL') {
          this.loadingRender = true
          var DataAxios = {
            ArryfildValue: '',
            Method: 'post',
            Action: 'Bill/BillRightel',
            Token: this.$session.get('TokenNetPa'),
          }
          const formData = new FormData()
          formData.append('customerCode',this.$session.get('CustCode'))
          formData.append('taahodatId', this.taahodatId)
          formData.append('mobileNumber', this.mobileNumber.replace('-', ''))
          formData.append('token', this.$session.get('TokenNetPa'))
          DataAxios.ArryfildValue = formData
          this.$PostFormData(DataAxios).then((res) => {
            try {
              let data = JSON.parse(res)
              if (data.Status.Code == 'Exception') {
                this.loadingRender = false
                this.$mySweetDefault('خطا', data.Status.Description, 'warning', 4000)
              }
              if (data.Status.Code == 'Success') {
                this.loadingRender = false
                this.estelamIsSuccess = true
                this.inquiryMobileData = data.Parameters.MidTerm
                this.setDebtorRecord(1300, 'هزینه استعلام قبض موبایل رایتل با شناسه  : ' + this.mobileNumber.replace('-', ''))
                this.saveBillInfo(14, this.mobileNumber, null, null)
                this.getBillInfo(14)
              }
            } catch (error) {
              if (res.status == false) {
                this.loadingRender = false
                this.$mySweetDefault('خطا', res.message, 'warning', 4000)
                return
              }
            }
          })
        }
      }
    },
    Inquiry_FixedLine() {
      if (this.$ValidForm('FixedLine')) {
        if (this.Taahodat.ghabelBardasht <= this.minMandeForInquiry) {
          this.$mySweetDefault('عدم موجودی', 'برای استعلام نباید موجودی حساب شما کمتر از ' + this.$Comma3ragham(this.minMandeForInquiry) + ' ' + this.$GetVahedPool() + ' باشد', 'warning', 4000)
          return
        }
        this.loadingRender = true
        var DataAxios = {
          ArryfildValue: '',
          Method: 'post',
          Action: 'Bill/BillFixedLine',
          Token: this.$session.get('TokenNetPa'),
        }
        const formData = new FormData()
        formData.append('customerCode',this.$session.get('CustCode'))
        formData.append('taahodatId', this.taahodatId)
        formData.append('fixedLineNumber', this.fixedLineNumber.replace('-', ''))
        formData.append('token', this.$session.get('TokenNetPa'))
        DataAxios.ArryfildValue = formData
        this.$PostFormData(DataAxios).then((res) => {
          try {
            let data = JSON.parse(res)
            if (data.Status.Code == 'Exception') {
              this.loadingRender = false
              this.$mySweetDefault('خطا', data.Status.Description, 'warning', 4000)
            }
            if (data.Status.Code == 'Success') {
              this.loadingRender = false
              this.estelamIsSuccess = true
              this.inquiryFixedLine = data.Parameters
              this.setDebtorRecord(1300, 'هزینه استعلام قبض تلفن ثابت با شناسه  : ' + this.fixedLineNumber)
              this.saveBillInfo(15, this.fixedLineNumber, null, null)
              this.getBillInfo(15)
            }
          } catch (error) {
            if (res.status == false) {
              this.loadingRender = false
              this.$mySweetDefault('خطا', res.message, 'warning', 4000)
              return
            }
          }
        })
      }
    },

    checkOperationSim() {
      this.estelamIsSuccess = false
      this.operationSim = ''
      let pishSim = this.mobileNumber.split('-')[0]
      this.listMobile.forEach((op) => {
        var key = Object.keys(op)
        var find = op[key].find((x) => x == pishSim)

        if (typeof find == 'string') {
          this.operationSim = key[0]
          return
        }
      })
    },
    getSelTaahodat() {
      let DataAxiosTaahodat = {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat',
        Token: this.$session.get('TokenNetPa'),
      }
      const formData = new FormData()
      formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      formData.append('wwwtblSarfaslTypeId', 2)
      DataAxiosTaahodat.ArryfildValue = formData
      this.$PostFormData(DataAxiosTaahodat).then((data) => {
        this.listTaahodat = data
      })
    },

    paymentWater(Bill, Taahodat) {
      if (Taahodat.ghabelBardasht >= Bill.Amount) {
        this.setDebtorRecord(Bill.Amount, ' قبض آب با شناسه : ' + this.waterBillId).then((res) => {
          if (res == true) {
            // this.paymentBill(Bill.BillID,Bill.PaymentID,Bill.Amount)
          }
        })
      } else {
        this.$mySweetDefault('عدم موجودی کافی', 'میزان موجودی حساب انتخابی شما کمتر از مبلغ قبض میباشد', 'warning', 3000)
      }
    },
    paymentElectricity(Bill, Taahodat) {
      if (Taahodat.ghabelBardasht >= Bill.Amount) {
        this.setDebtorRecord(Bill.Amount, ' قبض برق با شناسه : ' + this.electricityBillId).then((res) => {
          this.paymentBill(Bill.BillID, Bill.PaymentID, Bill.Amount)
        })
      } else {
        this.$mySweetDefault('عدم موجودی کافی', 'میزان موجودی حساب انتخابی شما کمتر از مبلغ قبض میباشد', 'warning', 3000)
      }
    },
    paymentGas(Bill, Taahodat) {
      if (Taahodat.ghabelBardasht >= Bill.Amount) {
        this.setDebtorRecord(Bill.Amount, ' قبض گاز با شناسه : ' + this.gasBillId + ' و کد اشتراک :: ' + this.gasParticipateCode).then((res) => {
          this.paymentBill(Bill.BillID, Bill.PaymentID, Bill.Amount)
        })
      } else {
        this.$mySweetDefault('عدم موجودی کافی', 'میزان موجودی حساب انتخابی شما کمتر از مبلغ قبض میباشد', 'warning', 3000)
      }
    },
    paymentMobile(Bill, Taahodat) {
      if (Taahodat.ghabelBardasht >= Bill.Amount) {
        this.setDebtorRecord(Bill.Amount, ' قبض موبایل با شناسه : ' + this.mobileNumber.replace('-', '')).then((res) => {
          this.paymentBill(Bill.BillID, Bill.PaymentID, Bill.Amount)
        })
      } else {
        this.$mySweetDefault('عدم موجودی کافی', 'میزان موجودی حساب انتخابی شما کمتر از مبلغ قبض میباشد', 'warning', 3000)
      }
    },
    paymentFixedLine(Bill, Taahodat) {
      if (Taahodat.ghabelBardasht >= Bill.Amount) {
        this.setDebtorRecord(Bill.Amount, ' قبض تلفن ثابت با شناسه : ' + this.fixedLineNumber).then((res) => {
          this.paymentBill(Bill.BillID, Bill.PaymentID, Bill.Amount)
        })
      } else {
        this.$mySweetDefault('عدم موجودی کافی', 'میزان موجودی حساب انتخابی شما کمتر از مبلغ قبض میباشد', 'warning', 3000)
      }
    },

    setDebtorRecord(Mablagh, typeBill) {
      return new Promise((success, reject) => {
        let DataAxios = {
          ArryfildValue: '',
          Method: 'Post',
          Action: 'EnteghalVajh',
          Token: this.$session.get('TokenNetPa'),
        }
        const formData = new FormData()
        formData.append('wwwtblAzaId',this.$session.get('UserInfoNetPa').wwwtblAzaId);
        formData.append('wwwtblTaahodatIdBestanKar', 0)
        formData.append('wwwtblTaahodatIdBedehKar', this.Taahodat.id)
        formData.append('Mablagh', Mablagh)
        formData.append('Desc', ' پرداخت قبض - ' + typeBill)
        formData.append('KodRahgiri', '')
        formData.append('CardNo', '')
        formData.append('ShebaNo', '')
        formData.append('NameSahebHesab', this.Taahodat.nameFamily)
        formData.append('EnteghalNoe', 6)
        formData.append('HesabNo', '')
        formData.append('OrderId', '-2')
        formData.append('MabKarmozdEnteghal', 0)
        formData.append('MabKarmozdBnp', 0)
        formData.append('BankName', '')
        formData.append('ComboIdGrp324', '')
        formData.append('TarixSanad', this.$store.state.JalaliDate)
        formData.append('tblcombiId330NoeEnteghal', 181070513)
        DataAxios.ArryfildValue = formData
        this.$PostFormData(DataAxios).then((data) => {
          if (data.success === 'SUCCESS') {
            success(true)
          } else {
            success(false)
            this.loadingRender = false
            this.$mySweetDefaultTost('خطا', 'در ثبت تراکنش استعلام خطایی به وجود آمده', 'warning', 2000)
          }
        })
      })
    },
    paymentBill(billId, paymentId, amount) {
      let data = {
        token: this.$session.get('TokenNetPa'),
        customerCode: this.$session.get('CustCode'),
        taahodatId: this.Taahodat.bnpCashDBtblTaahodatId,
        billId: billId,
        paymentId: paymentId,
        amount: amount,
      }
      this.$PostData_new('Bill/BillPayment', 'POST', data, false).then((res) => {
        let dataParse
        let result
        try {
          dataParse = JSON.parse(res)
          if (dataParse.Status.Code == 'Success') {
            this.loadingRender = false
            this.$mySweetDefault('عملیات موفق', dataParse.Status.Description, 'success', 4000)
            return
          } else {
            this.loadingRender = false
            this.$mySweetDefault('خطا', dataParse.Status.Description, 'warning', 4000)
          }
        } catch (error) {
          if (res.status == false) {
            this.loadingRender = false
            this.$mySweetDefault('خطا', res.message, 'warning', 4000)
            return
          }
        }
      })
    },

    saveBillInfo(BillTypeGrp53, BillId, ParticipateCode, FullName) {
      let data = {
        BnpCashDBTblAzaId: this.$session.get('UserInfoNetPa').bnpCashDBtblAzaId,
        BillTypeTblComboGrp53: BillTypeGrp53,
        BillId: BillId,
        ParticipateCode: ParticipateCode,
        FullName: FullName,
      }

      this.$PostData_new('Ghobooz/SaveBill', 'POST', data, false).then((res) => {
        this.getBillInfo(BillTypeGrp53)
      })
    },
    getBillInfo(BillTypeGrp53) {
      let DataAxios = {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'Ghobooz/GetBill',
        Token: this.$session.get('TokenNetPa'),
      }
      const formData = new FormData()
      formData.append('azaId', this.$session.get('UserInfoNetPa').bnpCashDBtblAzaId)
      formData.append('BillTypeTblComboGrp53', BillTypeGrp53)
      DataAxios.ArryfildValue = formData
      this.$PostFormData(DataAxios).then((data) => {
        // console.log('🤦🏻‍♂️ ~ file: BillPayment.vue:777 ~ data:', data)
        this.listSave = data
        // this.Render++
      })
    },
    deleteSave(item) {
      // console.log('🤦🏻‍♂️ ~ file: BillPayment.vue:783 ~ item:', item)
      let DataAxios = {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'Ghobooz/DeleteBill',
        Token: this.$session.get('TokenNetPa'),
      }
      const formData = new FormData()
      formData.append('id', item.id)
      DataAxios.ArryfildValue = formData
      this.$PostFormData(DataAxios).then((data) => {
        if (data.status == 'Ok') {
          this.getBillInfo(item.billTypeTblComboGrp53)
        }
      })
    },
    
    replaceGasSaved(item) {
      if (item.participateCode == null) {
        this.gasBillId = item.billId
        this.isBillGas = true
      } else {
        this.gasParticipateCode = item.participateCode
        this.isBillGas = false
      }
    },
    ReplaceMobileSave(item){
      this.mobileNumber = item.billId
      this.checkOperationSim()
    },
    // getBalance() {
    //   var DataAxios = {
    //     ArryfildValue: '',
    //     Method: 'post',
    //     Action: 'Bill/GetBalance',
    //     Token: this.$session.get('TokenNetPa'),
    //   }
    //   const formData = new FormData()
    //   formData.append('customerCode',this.$session.get('CustCode'))
    //   DataAxios.ArryfildValue = formData
    //   this.$PostFormData(DataAxios).then((res) => {
    //     console.log(res)
    //   })
    // },
  },
}
</script>
<style scoped>
.SELECT {
  background: blueviolet !important;
}
.Card {
  min-height: 48vh;
  background: #fff;
  border-radius: 10px;
  -webkit-box-shadow: 0px 0px 20px -11px rgba(102, 102, 102, 1);
  -moz-box-shadow: 0px 0px 20px -11px rgba(102, 102, 102, 1);
  box-shadow: 0px 0px 20px -11px rgba(102, 102, 102, 1);
  padding-top: 50px;
  padding-bottom: 50px;
}
</style>
<style scoped>
.cardGhabz_Water {
  background: #a4ebf070;
}

.cardGhabz_Gas {
  background: #c7430520;
}

.cardGhabz_Electricity {
  background: #d4c30530;
}

.cardGhabz_FixedLine {
  background: #76767630;
}

.cardGhabz_Mobile {
  background: #3400a320;
}

.btn-water {
  background: #a4ebf0;
}
.btn-gas {
  background: #c74305;
}
.btn-electricity {
  background: #d4c305;
}
.btn-fixedLine {
  background: #767676;
}
.btn-mobile {
  background: #3400a3;
}
.text-banafsh {
  color: #ad0491;
}

.border-dash-water {
  border-bottom: 2px dashed #a4ebf0;
}
.border-dash-gas {
  border-bottom: 2px dashed #c74305;
}
.border-dash-electricity {
  border-bottom: 2px dashed #d4c305;
}
.border-dash-Mobile {
  border-bottom: 2px dashed #3400a3;
}
.border-dash-fixedLine {
  border-bottom: 2px dashed #767676;
}

.border-dash-Mobile {
  border-bottom: 2px dashed #3400a3;
}

.cardGhabz {
  width: 120px;
  border-radius: 8px;
  padding: 10px;
  transition: 0.5s;
}
.infoSave {
  margin-top: 5px;
  background: #cacaca3f;
  border-radius: 5px;
}
.infoSave:hover .fa-trash {
  display: block;
}
.fa-trash {
  font-size: 18px;
  display: none;
}
</style>
